export default "__VITE_ASSET__UHyHd0jZ__"